// https://glidejs.com/docs/options/
import Glide, {Autoplay, Swipe} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.core.scss'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.theme.scss'; // tslint:disable-line

export class TopBarCTA {
  glide: Glide;

  constructor(topBarCta: HTMLElement) {
    if (topBarCta) {
      const speed = topBarCta.dataset.speed
        ? parseInt(topBarCta.dataset.speed, 10)
        : 3000;

      this.glide = new Glide('.glide', {
        autoplay: speed,
        perView: 1,
        type: 'carousel',
      }).mount({
        Autoplay,
        Swipe,
      });
    }
  }

  destroy() {
    this.glide.destroy();
  }
}
